import { useQuery } from '@tanstack/react-query';

import { get } from '../../../lib/api';

export const useFetchBroadcastsByYear = year => {
  const params = { year };

  const {
    data: { broadcasts_by_month: broadcastsByMonth = {} } = {},
    isFetching,
  } = useQuery(
    ['broadcasts-by-year', year],
    () => get('/api/client_admin/campaigns/by_year', params),
    {
      refetchOnWindowFocus: false,
      initialData: {
        broadcasts_by_month: {},
      },
    },
  );

  return {
    broadcastsByMonth,
    isFetching,
  };
};
